import React from "react";
import Aux from "../utils/AuxFunctions";
// import "./Register.css"
import "../account/Account.css"
import Fire from "../config/Fire";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SuccessMessage from "../utils/ErrorPages/SucessMessage"

import Colors from "../utils/Colors";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import QueryString from "query-string"
import { withMyDataContext } from "../context/DataProvider";
import axios from "axios";
import Loader from "../utils/Utilities/Loader";

class Invitation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingReferral: false,
            loadingCode: false,
            loadingCodeValue: false,
            loading: false,
            error: "",
            invitationReward: "",

            successCode: false,
            successReferral: false,

            user: {},
            noUser: false,
            uid: "",
            isUid: false,

            isCode: false,
            noCode: false,
            code: "",
        }
    }

    componentDidMount = async () => {
        try {
            const urlParams = QueryString.parse(this.props.location.search);
            if (urlParams.uid) {
                this.setState({ isUid: true })
                this.getUserInfo(urlParams.uid)
            } else if (urlParams.code) {
                this.setState({ isCode: true })
                const reward = await this.getCodeMoney(urlParams.code)
                if (reward) {
                    this.setState({ invitationReward: reward.reward, code: urlParams.code })
                } else {
                    this.setState({ noCode: true })
                }
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserInfo = async (uid) => {
        if (!uid) {
            return
        }
        try {
            this.setState({ loading: true })
            let userQuery = await Fire.shared.firestore.collection("users").doc(uid).get();
            if (userQuery.exists) {
                this.setState({ user: userQuery.data(), uid: uid })
                //this.props.myDataProvider.setPendingReferralUser(uid)
            } else {
                this.setState({ noUser: true })
            }
            this.setState({ loading: false })
        } catch (error) {
            this.setState({ loading: false })
            Aux.handleError(error)
        }
    }

    getCodeMoney = async (code) => {
        try {
            this.setState({ loadingCodeValue: true })
            const result = await axios.post(process.env.REACT_APP_API_URL_CODE, { code: code })
            if (result.status === 200) {
                this.setState({ loadingCodeValue: false })
                return result.data
            } else {
                this.setState({ loadingCodeValue: false })
                return false
            }
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingCodeValue: false })
        }

        // return promoCodes.find((element) => {
        //     return element.code === code;
        // })

    }

    checkIfPending = () => {
        if (this.state.code) {
            this.props.myDataProvider.setPendingCode(this.state.code, this.state.invitationReward)
        }
        if (this.state.uid) {
            this.props.myDataProvider.setPendingReferralUser(this.state.uid)
        }
    }

    goToLogin = () => {
        try {
            this.checkIfPending();
            this.props.history.push("/account/login")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goToRegister = () => {
        try {
            this.checkIfPending();
            this.props.history.push("/account/register")
        } catch (error) {
            Aux.handleError(error)
        }
    }

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    addCode = async () => {
        if (this.state.loadingCode)
            return
        try {
            this.setState({ loadingCode: true })
            const result = await Fire.shared.addPromoCode(this.state.code, this.state.invitationReward)
            if (result === 2) {
                this.setState({ error: "You already used that code" })
            } else {
                this.setState({ successCode: true })
            }
            this.setState({ loadingCode: false })
            this.props.myDataProvider.setPendingCode("", 0)
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingCode: false, error: "An unexpected error has occurred" })
        }
    }

    addReferralUser = async () => {
        if (this.state.loadingReferral)
            return;
        if (this.props.myDataProvider.user.referralUser) {
            this.setState({ error: "You've already got a referral User" })
            return;
        }
        if (!this.state.uid) {
            return;
        }
        if (this.state.uid === Fire.shared.uid) {
            this.setState({ error: "You can't use your own referral link" })
            return;
        }

        try {
            this.setState({ loadingReferral: true })
            await Fire.shared.InitialReferralLinkUid(this.state.uid).then(status => {
                if (status) {
                    this.setState({ successReferral: true, loadingReferral: false })
                    this.props.myDataProvider.setPendingReferralUser("")
                } else {
                    this.setState({ loadingReferral: false, error: "An unexpected error has occurred" })
                }
            })
        } catch (error) {
            Aux.handleError(error)
            this.setState({ loadingReferral: false, error: "An unexpected error has occurred" })
        }
    }

    isValid = () => {
        if (this.state.isUid) {
            if (this.props.myDataProvider.user?.referralUser || this.state.noUser || !this.state.user || this.state.successReferral) {
                return false
            } else {
                return true
            }
        } else if (this.state.isCode) {
            if (this.state.noCode || !this.state.code || this.state.successCode) {
                return false
            } else {
                return true
            }
        } else {
            return false
        }
    }

    render() {
        //const error = this.state.error;
        const loading = this.state.loading || this.state.loadingCodeValue
        const hasInvitation = this.state.user || this.state.code
        /* const isValid = this.state.isUid ? !this.props.myDataProvider.user?.referralUser || !this.state.noUser : 
            this.state.isCode ? !this.state.noCode : false */
        return (
            <div style={{ width: "100%" }}>

                <section className="container">
                    {/* <img alt="logo" src={Aux.LogoImage} style={{ width: 50, objectFit: "contain" }}></img> */}
                    <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
                        {/*  <ChevronLeftIcon style={{ marginRight: 5 }}></ChevronLeftIcon> */}
                        <h2>Invitation</h2>
                    </div>
                    <ErrorMessage text={this.state.error}></ErrorMessage>
                    {/*  <SuccessMessage isSucess={this.state.successCode || this.state.successReferral} text={this.state.successCode ? "Congratulations you've successfully added your code" : "Congratulations you've successfully added your referral user"}></SuccessMessage>*/}

                    {loading ?
                        <Loader></Loader>
                        :
                        this.state.isUid ?
                            this.state.successReferral ?
                                <div style={{ display: "flex", justifyContent: "center", margin: "0px 20px" }}>
                                    <SuccessMessage isSucess={this.state.successReferral} text={`Congratulations you've successfully added @${this.state.user.username} as your referral user`}></SuccessMessage>
                                </div>
                                :
                                this.props.myDataProvider.user?.referralUser && !this.state.successReferral && !this.state.loadingReferral ?
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <span>You've already got a referral user</span>
                                    </div>
                                    :
                                    this.state.noUser ?
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <span>Invalid refer user</span>
                                        </div>
                                        :
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                            {Aux.showAvatar(60, this.state.user.avatar, this.state.user.username)}
                                            <div style={{ marginTop: 10 }}>
                                                <span style={{ fontWeight: "600", color: Colors.middleText, marginLeft: 10 }}>@{this.state.user.username}</span>
                                            </div>
                                            <div style={{ marginTop: 20, marginBottom: 10 }}>
                                                <span style={{ color: "#777", fontWeight: "bold", fontSize: 16 }}>Wants to be your refer and give you <span style={{ color: Colors.green }}>10$</span>!</span>
                                            </div>
                                        </div>
                            : this.state.isCode ?
                                this.state.successCode ?
                                    <div style={{ display: "flex", justifyContent: "center", margin: "0px 20px" }}>
                                        <SuccessMessage isSucess={this.state.successCode} text={`Congratulations you've successfully added the code ${this.state.code}`}></SuccessMessage>
                                    </div>
                                    :
                                    this.state.noCode ?
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <span>Invalid code</span>
                                        </div> :
                                        <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                            <div style={{ marginTop: 20, marginBottom: 10 }}>
                                                <span style={{ color: "#777", fontWeight: "bold", fontSize: 16 }}>Do you want to use the code</span>
                                            </div>
                                            <div style={{ marginTop: 10, marginBottom: 10 }}>
                                                <span style={{ color: Colors.darkText, fontWeight: "bold", fontSize: 20 }}>{this.state.code}</span>
                                            </div>
                                            <div style={{ marginTop: 10, marginBottom: 10 }}>
                                                <span style={{ color: "#777", fontWeight: "bold", fontSize: 16 }}>and get a reward of
                                        <span style={{ color: Colors.green }}>{` `}{this.state.invitationReward}$</span>?</span>
                                            </div>
                                            {/* <div style={{ padding: "5px 20px", borderColor: Colors.green, borderStyle: "solid", borderWidth: 1, borderRadius: 10 }}>
                                        <span style={{ color: Colors.green, fontWeight: "bold", fontSize: 25 }}>{this.state.invitationReward}</span>
                                    </div> */}
                                        </div>


                                : <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <span>Get a valid invitation link</span>
                                </div>
                    }

                    {!loading && hasInvitation && this.isValid() ?
                        this.props.myDataProvider.loadingState === "connected" ?
                            <div style={{ marginTop: 30, }}>
                                <div style={{ margin: "10px 0", display: "flex", justifyContent: "center" }}>
                                    {this.state.isUid ?
                                        <div>
                                            <div style={{ marginTop: 20, marginBottom: 10 }}>
                                                <span style={{ color: Colors.darkText, fontWeight: "bold", fontSize: 16 }}>Add as your refer?</span>
                                            </div>
                                        </div>
                                        : null}
                                </div>

                                {this.state.declined ?
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <span>Declined</span>
                                    </div>
                                    : <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", }}>
                                        <ButtonLoader
                                            text="Decline"
                                            onClick={() => { this.setState({ declined: true }) }}
                                            style={{ color: "#777", borderColor: "#777", borderStyle: "solid", borderWidth: 1, backgroundColor: "transparent", width: "40%" }}
                                        />
                                        <ButtonLoader
                                            text="Accept"
                                            loading={this.state.loadingReferral || this.state.loadingCode}
                                            isFinished={this.state.successReferral || this.state.successCode}
                                            onClick={() => {
                                                if (this.state.isCode) {
                                                    this.addCode()
                                                } else if (this.state.isUid) {
                                                    this.addReferralUser()
                                                }

                                            }}
                                            style={{ color: "white", backgroundColor: Colors.mainColor, width: "40%" }}
                                        />
                                    </div>
                                }
                            </div> :
                            this.props.myDataProvider.loadingState === "disconnected" ?
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 20 }}>
                                    <div>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <span style={{ color: Colors.softText }}>You have to be logged in to continue</span>
                                        </div>
                                        <div style={{ marginTop: 30, marginBottom: 5 }}>
                                            <span style={{ color: "#777" }}>Already have an account? </span>
                                        </div>
                                        <ButtonLoader
                                            text="Login"
                                            style={{ backgroundColor: Colors.mainColor, height: 45, width: "100%", marginTop: 10, marginBottom: 10 }}
                                            onClick={() => this.goToLogin()}
                                        />
                                        <div style={{ margin: "10px 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <span style={{ color: Colors.softText }}>Or</span>
                                        </div>
                                        <div style={{ marginTop: 10, marginBottom: 5 }}>
                                            <span style={{ color: "#777", marginTop: 10 }}>Register for free and get an additional <span style={{ color: Colors.green, fontWeight: "bold" }}>20$</span></span>
                                        </div>
                                        <ButtonLoader
                                            text="Register"
                                            style={{ backgroundColor: Colors.red, height: 45, width: "100%", marginTop: 10 }}
                                            onClick={() => this.goToRegister()}
                                        />
                                    </div>
                                </div>
                                :
                                <Loader></Loader>
                        : null
                    }
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 20 }} className="text-hover" onClick={() => this.props.history.push("/")}>
                        <span style={{ color: Colors.mainColor }}>Close</span>
                    </div>
                </section>

            </div>
        );
    }
}

export default withMyDataContext(Invitation);